<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.mobile"
    width="1000"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        small
        v-on="on"
        v-bind="attrs"
        color="primary"
        :disabled="selectedAffiliates.length === 0"
      >
        <v-icon v-show="$vuetify.breakpoint.width > 370" small left>
          mdi-cash
        </v-icon>

        <span
          :style="$vuetify.breakpoint.width < 370 ? 'font-size: 0.7rem;' : ''"
        >
          {{ $t("payments.makePayment") }}
        </span>
      </v-btn>
    </template>
    <v-card>
      <div>
        <v-app-bar>
          <div class="title text">
            {{ $t("payments.makePayment") }}
          </div>
          <v-spacer></v-spacer>
          <v-btn
            class="mr-1"
            small
            icon
            @click="dialog = false"
            :disabled="loading"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-app-bar>
        <v-card-text class="pa-4">
          <v-card class="pa-2 mb-4" outlined>
            <div>
              {{
                $t("payments.makingPayment.affiliatesBeingPaid", {
                  count: selectedAffiliates.length,
                })
              }}
            </div>
            <div>
              {{ $t("payments.makingPayment.totalValue") }}
              <span class="red--text">R$ {{ valueOfPayment.toFixed(2) }}</span>
            </div>
            <div>
              {{ $t("date") }}:
              {{ new Date().toLocaleDateString() }}
            </div>
          </v-card>
          <v-data-table
            :items="selectedAffiliates"
            :headers="headers"
            fixed-header
            height="400"
            :footer-props="{
              'items-per-page-text': this.$t('rowsPerPage'),
            }"
          >
            <template v-slot:item.affiliate_id="{ item }">
              <v-btn x-small @click="$copy(item.affiliate_id)">
                {{ item.affiliate_id }}
              </v-btn>
            </template>

            <template v-slot:item.local_name="{ item }">
              <a
                class="green--text"
                @click="
                  $profile.showProfileDrawer(
                    item.local_id,
                    `/${$prefix()}/affiliates/getLocal`
                  )
                "
              >
                <v-icon color="green" small>mdi-account-multiple</v-icon>
                {{ item.local_name }} <small>({{ item.local_id }})</small>
              </a>
            </template>

            <template v-slot:item.regional_name="{ item }">
              <a
                class="orange--text"
                @click="
                  $profile.showProfileDrawer(
                    item.regional_id,
                    `/${$prefix()}/affiliates/getRegional`
                  )
                "
              >
                <v-icon color="orange" small>mdi-account-tie</v-icon>
                {{ item.regional_name }} <small>({{ item.regional_id }})</small>
              </a>
            </template>

            <template v-slot:item.affiliate_name="{ item }">
              <a
                class="blue--text"
                @click="
                  $profile.showProfileDrawer(
                    item.affiliate_id,
                    `/${$prefix()}/affiliates/getAffiliate`
                  )
                "
              >
                <v-icon color="blue" small>mdi-account</v-icon>
                {{ item.affiliate_name }}
              </a>
            </template>

            <template v-slot:item.player_login="{ item }">
              <div>
                <v-icon small color="green">
                  mdi-check
                </v-icon>
                <a
                  style="cursor: pointer;"
                  @click="
                    $router.push({
                      name: `${
                        $prefix() === 'colab' ? 'Collaborator' : 'Administrator'
                      }AccountabilityOnlinePlayersOnlineSearch`,
                      query: { id_user: item.bound_player },
                    })
                  "
                >
                  {{ item.player_login }}
                </a>
              </div>
            </template>

            <template v-slot:item.ngr_value="{ item }">
              <span class="green--text">
                {{ item.ngr_value }}
              </span>
            </template>

            <template v-slot:item.ggr_value="{ item }">
              <span class="green--text">
                {{ item.ggr_value }}
              </span>
            </template>

            <template v-slot:item.gross_value="{ item }">
              <span class="green--text">
                {{ item.gross_value }}
              </span>
            </template>

            <template v-slot:item.prize_value="{ item }">
              <span class="red--text">
                {{ item.prize_value }}
              </span>
            </template>

            <template v-slot:item.fee_value="{ item }">
              <span class="red--text">
                {{ item.fee_value }}
              </span>
            </template>

            <template v-slot:item.commission_value="{ item }">
              <span class="red--text">{{ item.commission_value }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false" :disabled="loading">
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn color="primary" text @click="confirmPayment" :loading="loading">
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["selectedAffiliates", "allSelected"],

  data: () => ({
    dialog: false,
    loading: false,
  }),

  computed: {
    headers() {
      return [
        { text: this.$t("idAffiliate"), value: "affiliate_id" },
        // { text: this.$t("mRegional"), value: "regional_name" },
        // { text: this.$t("mLocal"), value: "local_name" },
        { text: this.$t("affiliateName"), value: "affiliate_name" },
        { text: this.$t("payments.linkedPlayer"), value: "player_login" },
        {
          text: this.$t("revenues"),
          value: "gross_value",
          align: "start",
        },
        {
          text: this.$t("awards"),
          value: "prize_value",
          align: "start",
        },
        {
          text: "GGR",
          value: "ggr_value",
          align: "start",
        },
        {
          text: this.$t("feeValue"),
          value: "fee_value",
          align: "start",
        },
        {
          text: "NGR",
          value: "ngr_value",
          align: "start",
        },
        {
          text: this.$t("commissionValue"),
          value: "commission_value",
        },
      ];
    },
    valueOfPayment() {
      return this.selectedAffiliates.reduce(
        (n, { commission_value }) => n + Number(commission_value),
        0
      );
    },
  },

  methods: {
    confirmPayment() {
      const { year, month } = this.$store.getters.getMonthAndYearOfPayment;

      const body = {
        year,
        month,
      };

      const affiliates = {};

      let i = 0;
      for (const affiliate of this.selectedAffiliates) {
        affiliates[`affiliateIds[${i}]`] = affiliate.affiliate_id;
        i++;
      }

      Object.assign(body, affiliates);

      this.loading = true;

      this.$axios
        .post(`${this.$prefix()}/financial/payAffiliates`, this.$formdata(body))
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });

          this.$emit("removeAffiliates", res.data.dados);
          
          this.dialog = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
